"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _context, _context2;

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

var _exportNames = {
  registBmFormCoreItems: true
};
exports.registBmFormCoreItems = void 0;

var _formDefaultEngine = require("../../core/render/items/form-default-engine");

var _variableForm = require("../../core/render/items/variable-form");

var _inputFields = require("./input-fields");

_forEachInstanceProperty(_context = _Object$keys(_inputFields)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _inputFields[key];
    }
  });
});

var _statics = require("./statics");

_forEachInstanceProperty(_context2 = _Object$keys(_statics)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;

  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _statics[key];
    }
  });
});

var registBmFormCoreItems = function registBmFormCoreItems() {
  (0, _inputFields.registerRadioInputFieldItem)();
  (0, _inputFields.registerDateInputFieldItem)();
  (0, _inputFields.registerTextInputFieldItem)();
  (0, _inputFields.registerNumberInputFieldItem)();
  (0, _statics.registerStaticLabelItem)();
  (0, _statics.registerDynamicLabelItem)();
  (0, _formDefaultEngine.registerBmFormItem)();
  (0, _inputFields.registerDropdownInputFieldItem)();
  (0, _variableForm.registerVariableFormItem)();
  (0, _inputFields.registerCheckboxEngine)();
};

exports.registBmFormCoreItems = registBmFormCoreItems;
